import type { FC } from 'react';

import { EntityPageFocusType } from '@xing-com/crate-common-graphql-types';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';

import { EntityInfoCompany } from './entity-info-company';
import { EntityInfoPublisherPage } from './entity-info-publisher-page';
import { EntityInfoTopicPage } from './entity-info-topic-page';

export const EntityInfoContainer: FC = () => {
  const { pageContext } = usePageContext();
  const focusType = pageContext.focusType;

  if (focusType === EntityPageFocusType.TopicPage) {
    return <EntityInfoTopicPage />;
  }
  if (focusType === EntityPageFocusType.Company) {
    return <EntityInfoCompany />;
  }
  if (focusType === EntityPageFocusType.Publisher) {
    return <EntityInfoPublisherPage />;
  }
  return null;
};
